import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'subtypeConverter'
})
export class SubtypeConverterPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'Boolean':
        return 'Checkbox';
      case 'Double':
        return 'Number';
      default:
        return value;
    }
  }
}
